import { htmlSafe } from '@ember/template';

export default function highlightText(text: string, searchQuery: string): ReturnType<typeof htmlSafe> {
  if (!searchQuery || !text) {
    return htmlSafe(text || '');
  }

  // @ts-expect-error: RegExp.escape may not exist on all environments
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const escapedSearchQuery = RegExp.escape(searchQuery);
  const regex = new RegExp(`(${escapedSearchQuery})`, 'gi');
  const highlightedText = text.replace(regex, '<mark class="bg-pistachio-10 px-1 rounded">$1</mark>');

  return htmlSafe(highlightedText);
}
